// Generated by ReScript, PLEASE EDIT WITH CARE


function fromString(x) {
  switch (x) {
    case "production" :
        return /* Production */0;
    case "staging" :
        return /* Staging */1;
    default:
      return /* Development */2;
  }
}

function toString(x) {
  switch (x) {
    case /* Production */0 :
        return "production";
    case /* Staging */1 :
        return "staging";
    case /* Development */2 :
        return "development";
    
  }
}

export {
  fromString ,
  toString ,
  
}
/* No side effect */
